import cnh from '~/helpers/cnh';
import styles from '~/styles/bookingFlow/information-card.module.css';

type Props = {
  title: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
  paddingLess?: boolean;
};

export default function InformationCard({
  title,
  description,
  children,
  className,
  paddingLess = false,
}: Props) {
  return (
    <div
      className={cnh(
        styles.informationCard,
        className,
      )}
    >
      <div className={styles.informationCardHead}>
        <h3 className={styles.informationCardTitle}>
          {title}
        </h3>

        {description && (
          <p className={styles.informationCardDescription}>
            {description}
          </p>
        )}
      </div>

      <div
        className={cnh(
          styles.informationCardBody,
          paddingLess ? styles.informationCardPaddingLess : '',
        )}
      >
        {children}
      </div>
    </div>
  );
}
